import React from 'react';
import { usePermissions } from '../../utils/usePermissions';
import { useAuth } from '../../contexts/AuthContext';

interface RequireStorageAccessProps {
  /** Фолбек, если нет прав (по умолчанию: null) */
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Компонент для проверки доступа к хранилищу секретов.
 * Проверяет наличие одного из следующих пермишнов:
 * - secrets:records:list (глобальный доступ ко всем записям)
 * - secrets:records:list_granted (доступ к записям с грантами)
 * - secrets:records:list:{code} (доступ к записям конкретного шаблона)
 */
const RequireStorageAccess: React.FC<RequireStorageAccessProps> = ({ fallback = null, children }) => {
  const { hasPermission, permissions } = usePermissions();
  const { isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  const hasAccess =
    hasPermission('secrets:records:list') ||              // Глобальный доступ ко всем записям
    hasPermission('secrets:records:list_granted') ||      // Доступ к записям с грантами
    // Или доступ к записям хотя бы одного шаблона
    (Array.isArray(permissions) && permissions.some(p => p.startsWith('secrets:records:list:')));

  if (!hasAccess) return <>{fallback}</>;
  return <>{children}</>;
};

export default RequireStorageAccess;
